<div class="user-setting">
  <a href="javascript:" [matMenuTriggerFor]="menu" class="text-muted">
    <svg class="pc-icon">
      <use xlink:href="assets/fonts/custom-icon.svg#custom-sort-outline"></use>
    </svg>
  </a>
  <mat-menu #menu="matMenu" [overlapTrigger]="false" yPosition="below" xPosition="after">
    <button mat-menu-item (click)="navigateAccount()">
      <a href="javascript:" class="text-muted">
        <i class="ti ti-user f-18 m-r-10"></i>
        <span>{{ myAccount$ | async }}</span>
      </a>
    </button>

    <button (click)="logout()" mat-menu-item>
      <a href="javascript:" class="text-muted">
        <i class="ti ti-power f-18 m-r-10"></i>
        <span>{{ logout$ | async}}</span>
      </a>
    </button>
  </mat-menu>
</div>
